import { useState } from "react";
import { MessageCircle, Facebook, Send, Link2, Check } from "lucide-react";
import { toast } from "sonner";
import { useTheme } from "@/context/ThemeContext";

function XIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function ShareBar({ title = "", className = "", testid = "share-bar" }) {
  const [copied, setCopied] = useState(false);
  const [hovered, setHovered] = useState(null);
  const { theme } = useTheme();
  const url = typeof window !== "undefined" ? window.location.href : "";
  const enc = encodeURIComponent;

  const xColor = theme === "dark" ? "#ffffff" : "#0f0f0f";

  const targets = [
    { key: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc(title + " " + url)}`, color: "#25D366" },
    { key: "facebook", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`, color: "#1877F2" },
    { key: "x", label: "X", icon: XIcon, href: `https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(url)}`, color: xColor },
    { key: "telegram", label: "Telegram", icon: Send, href: `https://t.me/share/url?url=${enc(url)}&text=${enc(title)}`, color: "#26A5E4" },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copiato");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  return (
    <div data-testid={testid} className={`flex items-center gap-2 ${className}`}>
      <span className="text-[11px] font-mono uppercase tracking-wider text-subtle mr-1 hidden sm:inline">Condividi</span>
      {targets.map(({ key, label, icon: Icon, href, color }) => {
        const active = hovered === key;
        return (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Condividi su ${label}`}
            data-testid={`share-${key}`}
            onMouseEnter={() => setHovered(key)}
            onMouseLeave={() => setHovered(null)}
            style={active ? { color, borderColor: color } : undefined}
            className="w-9 h-9 flex items-center justify-center rounded-full border border-hair bg-surfaceSecondary text-onSurfaceSecondary transition-colors"
          >
            <Icon size={16} />
          </a>
        );
      })}
      <button
        onClick={copy}
        aria-label="Copia link"
        data-testid="share-copy"
        className="w-9 h-9 flex items-center justify-center rounded-full border border-hair bg-surfaceSecondary text-onSurfaceSecondary hover:text-brand hover:border-brand/50 transition-colors"
      >
        {copied ? <Check size={16} className="text-ok" /> : <Link2 size={16} />}
      </button>
    </div>
  );
}
